import React from "react";
import "./puja-campaign-output-loader.scss";

import ChildLoader from "./childLoader";
import TextLoader from "./textLoader";
import TimeLoader from "./timeLoader";

export default function OutputLoader() {
  return (
    <div className={`flex-col-center PujaCampaignOutputLoader`}>
      <ChildLoader />

      <div className="flex-row-center bottomContainer">
        <TimeLoader />
        <TextLoader />
      </div>
    </div>
  );
}
